<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "parent-loader" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading" }, [
      _c("div", { staticClass: "effect-1 effects" }),
      _c("div", { staticClass: "effect-2 effects" }),
      _c("div", { staticClass: "effect-3 effects" }),
    ])
  },
]
render._withStripped = true





//
//
//
//
//
//
//
//
//

 export default ({
  render,
  staticRenderFns,
  name: "Loader",
  props: ["show"]
});


</script>

<style scoped>
.parent-loader {
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1051;
}[dir] .parent-loader {
  background: rgba(54, 53, 53, 0.1);
}[dir=ltr] .parent-loader {
  left: 0;
}[dir=rtl] .parent-loader {
  right: 0;
}
.parent-loader .loading-logo {
  position: relative;
}
.parent-loader .loading {
  position: relative;
}
</style>
